export default __webpack_public_path__ + "static/footer-girl-e870ca440279b21be659f56b3cffc66c.png";